module.exports = __webpack_public_path__ + "img/22.82344e92.webp";